import Cookies from 'js-cookie';
import { iCookieService } from './cookie.types';

export class CookieService implements iCookieService {
  constructor(private cookieProvider: Cookies.CookiesStatic) { }

  get(name: string) {
    return this.cookieProvider.get(name);
  }

  set(name: string, value: any): void {
    this.cookieProvider.set(name, value);
  }
}
